"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@nextui-org/react");
var react_2 = require("react");
var react_redux_1 = require("react-redux");
var update_client_token_management_1 = require("../../../../../api/calls/client/update_client_token_management");
var main_1 = require("../../../../../reducers/slices/main");
var get_client_thunk_1 = require("../../../../../reducers/slices/client/thunks/get_client_thunk");
var TOKEN_EXPIRY_OPTIONS = [
    { value: "1h", label: "1 Hour" },
    { value: "2h", label: "2 Hours" },
];
var REFRESH_TOKEN_EXPIRY_OPTIONS = [
    { value: "1d", label: "1 Day" },
    { value: "2d", label: "2 Days" },
];
var TokenManagement = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var token_management = (0, react_redux_1.useSelector)(function (state) { return state.clientState; }).client.token_management;
    var _a = (0, react_2.useState)(token_management || {
        expires: true,
        token_expires_in: "1h",
        refresh_token_expires_in: "2d",
    }), config = _a[0], setConfig = _a[1];
    var _b = (0, react_2.useState)(false), loading = _b[0], setLoading = _b[1];
    var validateConfig = function (config) {
        if (!config.expires)
            return true;
        var validTokenExpiry = TOKEN_EXPIRY_OPTIONS.some(function (opt) { return opt.value === config.token_expires_in; });
        var validRefreshExpiry = REFRESH_TOKEN_EXPIRY_OPTIONS.some(function (opt) { return opt.value === config.refresh_token_expires_in; });
        if (!validTokenExpiry || !validRefreshExpiry) {
            dispatch((0, main_1.setMessageModal)({
                title: "Error",
                messages: ["Invalid token expiry values. Please select from the available options."],
            }));
            return false;
        }
        return true;
    };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!validateConfig(config))
                        return [2 /*return*/];
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, (0, update_client_token_management_1.update_client_token_management)({ token_management: config })];
                case 2:
                    response = _a.sent();
                    if (response.success) {
                        dispatch((0, main_1.setMessageModal)({
                            title: "Success",
                            messages: ["Token management settings updated successfully"],
                        }));
                        dispatch((0, get_client_thunk_1.get_client_thunk)());
                    }
                    else {
                        dispatch((0, main_1.setMessageModal)({
                            title: "Error",
                            messages: [response.message || "Failed to update token management settings"],
                        }));
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    dispatch((0, main_1.setMessageModal)({
                        title: "Error",
                        messages: ["An unexpected error occurred"],
                    }));
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleExpiresChange = function (checked) {
        setConfig(function (prev) { return (__assign(__assign({}, prev), { expires: checked })); });
    };
    var handleTokenExpiryChange = function (value) {
        setConfig(function (prev) { return (__assign(__assign({}, prev), { token_expires_in: value })); });
    };
    var handleRefreshTokenExpiryChange = function (value) {
        setConfig(function (prev) { return (__assign(__assign({}, prev), { refresh_token_expires_in: value })); });
    };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "flex flex-col gap-4" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-6" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex items-center justify-between" }, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h3", __assign({ className: "text-lg font-semibold" }, { children: "Enable Token Expiration" })), (0, jsx_runtime_1.jsx)("p", __assign({ className: "text-sm text-default-400" }, { children: "Enable or disable token expiration" }))] }), (0, jsx_runtime_1.jsx)(react_1.Switch, { isSelected: config.expires, onValueChange: handleExpiresChange })] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-4" }, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h3", __assign({ className: "text-lg font-semibold mb-2" }, { children: "Token Expiration Time" })), (0, jsx_runtime_1.jsx)("p", __assign({ className: "text-sm text-default-400 mb-2" }, { children: "Set how long access tokens remain valid" })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex flex-col gap-2" }, { children: (0, jsx_runtime_1.jsx)(react_1.Select, __assign({ label: "Expiration Time", selectedKeys: [config.token_expires_in], onChange: function (e) { return handleTokenExpiryChange(e.target.value); }, className: "w-full", isDisabled: !config.expires }, { children: TOKEN_EXPIRY_OPTIONS.map(function (option) { return ((0, jsx_runtime_1.jsx)(react_1.SelectItem, __assign({ value: option.value }, { children: option.label }), option.value)); }) })) }))] }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h3", __assign({ className: "text-lg font-semibold mb-2" }, { children: "Refresh Token Expiration Time" })), (0, jsx_runtime_1.jsx)("p", __assign({ className: "text-sm text-default-400 mb-2" }, { children: "Set how long refresh tokens remain valid" })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex flex-col gap-2" }, { children: (0, jsx_runtime_1.jsx)(react_1.Select, __assign({ label: "Expiration Time", selectedKeys: [config.refresh_token_expires_in], onChange: function (e) { return handleRefreshTokenExpiryChange(e.target.value); }, className: "w-full", isDisabled: !config.expires }, { children: REFRESH_TOKEN_EXPIRY_OPTIONS.map(function (option) { return ((0, jsx_runtime_1.jsx)(react_1.SelectItem, __assign({ value: option.value }, { children: option.label }), option.value)); }) })) }))] })] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex justify-end" }, { children: (0, jsx_runtime_1.jsx)(react_1.Button, __assign({ color: "primary", onClick: handleSave, isLoading: loading }, { children: "Save Changes" })) }))] })) })));
};
exports.default = TokenManagement;
